import React, { Suspense } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import * as RoutePath from './shared/utils/routeLink';
import LoadingComponent from './component/LoadingComponent/LoadingComponent';

const MainComponent = React.lazy(() => import('./container/MainComponent/MainComponet'));

const Router = () => {
	return (
		<BrowserRouter
			future={{
				v7_startTransition: true,
				v7_relativeSplatPath: true,
			}}>
			<Routes>
				<Route
					path={RoutePath.ROOT}
					element={
						<Suspense fallback={<LoadingComponent />}>
							<MainComponent />
						</Suspense>
					}
				/>
				<Route
					path={RoutePath.HOME}
					element={
						<Suspense fallback={<LoadingComponent />}>
							<MainComponent />
						</Suspense>
					}
				/>
				<Route
					path={RoutePath.DASHBOARD}
					element={
						<Suspense fallback={<LoadingComponent />}>
							<MainComponent />
						</Suspense>
					}
				/>
				<Route
					path={RoutePath.SIGNIN}
					element={
						<Suspense fallback={<LoadingComponent />}>
							<MainComponent />
						</Suspense>
					}
				/>
				<Route
					path={RoutePath.LOGIN_BELAJAR_ID}
					element={
						<Suspense fallback={<LoadingComponent />}>
							<MainComponent />
						</Suspense>
					}
				/>
				<Route
					path={RoutePath.BELAJAR_VERIFY}
					element={
						<Suspense fallback={<LoadingComponent />}>
							<MainComponent />
						</Suspense>
					}
				/>
				<Route
					path={RoutePath.BELAJAR_SCHOOL_NOT_FOUND}
					element={
						<Suspense fallback={<LoadingComponent />}>
							<MainComponent />
						</Suspense>
					}
				/>
				<Route
					path={RoutePath.BELAJAR_STUDENT_NO_CLASS}
					element={
						<Suspense fallback={<LoadingComponent />}>
							<MainComponent />
						</Suspense>
					}
				/>
				<Route
					path={RoutePath.SIGNUP}
					element={
						<Suspense fallback={<LoadingComponent />}>
							<MainComponent />
						</Suspense>
					}
				/>
				<Route
					path={RoutePath.FORGOTPASSWORD}
					element={
						<Suspense fallback={<LoadingComponent />}>
							<MainComponent />
						</Suspense>
					}
				/>
				<Route
					path={RoutePath.FORGOTPASSWORDMETHOD}
					element={
						<Suspense fallback={<LoadingComponent />}>
							<MainComponent />
						</Suspense>
					}
				/>
				<Route
					path={RoutePath.RESETPASSWORD}
					element={
						<Suspense fallback={<LoadingComponent />}>
							<MainComponent />
						</Suspense>
					}
				/>
				<Route
					path={RoutePath.VERIFYUSER}
					element={
						<Suspense fallback={<LoadingComponent />}>
							<MainComponent />
						</Suspense>
					}
				/>
				<Route
					path={RoutePath.TNC}
					element={
						<Suspense fallback={<LoadingComponent />}>
							<MainComponent />
						</Suspense>
					}
				/>
				<Route
					path={RoutePath.PRIVACY_POLICY}
					element={
						<Suspense fallback={<LoadingComponent />}>
							<MainComponent />
						</Suspense>
					}
				/>
				<Route
					path={RoutePath.HELP}
					element={
						<Suspense fallback={<LoadingComponent />}>
							<MainComponent />
						</Suspense>
					}
				/>
				<Route
					path={RoutePath.ABOUT}
					element={
						<Suspense fallback={<LoadingComponent />}>
							<MainComponent />
						</Suspense>
					}
				/>
				<Route
					path={RoutePath.LMS}
					element={
						<Suspense fallback={<LoadingComponent />}>
							<MainComponent />
						</Suspense>
					}
				/>
				<Route
					path={RoutePath.SMS}
					element={
						<Suspense fallback={<LoadingComponent />}>
							<MainComponent />
						</Suspense>
					}
				/>
				<Route
					path={RoutePath.CONTACT_US}
					element={
						<Suspense fallback={<LoadingComponent />}>
							<MainComponent />
						</Suspense>
					}
				/>
				<Route
					path={RoutePath.SUCCESS_SENT_EMAIL_LINK}
					element={
						<Suspense fallback={<LoadingComponent />}>
							<MainComponent />
						</Suspense>
					}
				/>
				<Route
					path="*"
					element={
						<Suspense fallback={<LoadingComponent />}>
							<MainComponent />
						</Suspense>
					}
				/>
			</Routes>
		</BrowserRouter>
	);
};
export default Router;
